<template>
  <div class="onlineRechnerWrapper">
    <v-container>
      <v-row>
        <v-col class="textwrapper">
          <TextWrapper />
        </v-col>

        <v-col class="formularWrapper">
          <FormularWrapper />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TextWrapper from "./TextWrapper";
import FormularWrapper from "./FormularWrapper";
export default {
  name: "OnlineRechnerWrapper",

  components: {
    TextWrapper,
    FormularWrapper
  },

  data: () => ({
    password: null
  })
};
</script>

<style>
.onlineRechnerWrapper {
  background-color: #fab500;
}

.trialPassword {
  height: 200px;
}
</style>